import React from 'react'
import { useParams, useHistory } from 'react-router'
import { useEffect, useState, useRef } from 'react'
import util from '../../util/util'
import { Modal, Spin } from 'antd'
import Devicegraph from '../../component/patient/forms/devicegraph'
import { chain, find, hasIn, isEmpty } from 'lodash'
import { useWindowsSize } from '../../component'
import { constants } from '../../constants'
import SessionStorage from '../../util/sessionstore'
import { getPatient } from '../../store/action/patient.action'
import { getDeviceSchedule } from '../../store/action/device.action'
import { connect } from 'react-redux'

const DeviceMeasurementView = (props) => {
  const session = new SessionStorage()
  const size = useWindowsSize()
  const [width, setWidth] = useState()
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' &&
      window.innerWidth < constants.MOBILE_MAXWIDTH
  )
  const [spin, setSpin] = useState(false)
  const [patient, setPatient] = useState({})
  const [showModal, setShowModal] = useState(false)
  const [device, setDevice] = useState({})
  const { token, patientid, deviceid } = useParams()

  useEffect(() => {
    let modalWidth =
      (window.innerWidth < window.innerHeight
        ? window.innerWidth
        : window.innerHeight) - 20
    modalWidth = modalWidth < 400 ? modalWidth : 400
    setWidth(modalWidth)
    setIsMobile(window.innerWidth < constants.MOBILE_MAXWIDTH)
  }, [size])

  useEffect(() => {
    const decodedToken = util.verifyToken(token, true)
    if (token && !isEmpty(decodedToken) && decodedToken._id) {
      setSpin(true)
      ;(async () => {
        try {
          session.setProfile({ token })
          await props.fetchPatient(decodedToken._id)
          await props.getDeviceSchedule(decodedToken._id)
        } catch (error) {
          console.log(error)
          setSpin(false)
        }
      })()
    }
  }, [])

  useEffect(() => {
    if (props.patient) {
      if (hasIn(props.patient, 'deviceSchedule.assigneddevices')) {
        const { assigneddevices } = props.patient.deviceSchedule
        const device = find(assigneddevices, (dev) => deviceid == dev.deviceid)
        if (device) {
          setDevice({ ...device })
          setShowModal(true)
        }
      }
    }
  }, [props.patient])

  const renderDevice = () => {
    return chain(device?.valueDesc)
      .groupBy('metric')
      .map((parameters, key) => {
        return parameters[0].isOutput ? (
          <>
            <Devicegraph
              isLoading={(flag) => {
                setSpin(flag)
              }}
              dev={{
                ...device,
                metric_name: key,
                parameter: parameters[0].parameter,
                patientid: patientid,
              }}
              showTable={true}
              width={width}
              hideBorder={true}
            />
          </>
        ) : (
          <></>
        )
      })
      .value()
  }

  return (
    <>
      {isMobile && (
        <Spin spinning={props.isLoading || spin} style={{ marginTop: 50 }}>
          {device && renderDevice()}
        </Spin>
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    hasError: state.profile.error,
    message: state.profile.message,
    isLoading: state.patient.isLoading,
    assignedDevices: state.device.assignedDevices,
    patient: state.patient.patient,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPatient: (id) => dispatch(getPatient(id)),
    getDeviceSchedule: (patientid) => dispatch(getDeviceSchedule(patientid)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceMeasurementView)
